import classNames from 'classnames';
import './status-badge.scss';

export type StatusBadgeType = 'grey' | 'green' | 'yellow' | 'red' | 'dark-grey';

export const StatusBadge = ({ label, type }: { label: string; type: StatusBadgeType }) => {
  return (
    <span className={classNames('status-badge', `status-badge-${type}`)} data-cy="status-badge">
      {label}
    </span>
  );
};
